module.exports = __webpack_public_path__ + "img/开关D2.ec4d07fe.png";